export var groundingStatus;
(function (groundingStatus) {
    groundingStatus["ACTIVE"] = "active";
    groundingStatus["INACTIVE"] = "inactive";
})(groundingStatus || (groundingStatus = {}));
